import React from 'react'
import Modal from 'react-modal'
import {FormattedMessage} from 'react-intl'
import {connect} from 'react-redux'

import Icon from './Icon'

import toggleLoginRequiredModal from '../actions/toggleLoginRequiredModal'

//TODO this style should be extracted into a css style
const customStyles = {
  content : {
    overflow: 'auto',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: "500px"
  },
  overlay: {
    zIndex: "1000"
  }
}

const LoginRequiredModal = ({isOpen, onToggle}) => {
  return <Modal isOpen={isOpen} onRequestClose={onToggle} style={customStyles}>

    <div className="modal-header">
      <button className="close" onClick={onToggle}>
        <Icon name="times"></Icon>
      </button>

      <h4 className="modal-title">
        <FormattedMessage
          id="Login required"
          defaultMessage="Login required"/>
      </h4>

    </div>
    <div className="modal-body">
        <FormattedMessage
          id="Before doing this, you need to login"
          defaultMessage="Before doing this, you need to login"/>

    </div>    
    
  </Modal>
}

LoginRequiredModal.propTypes = {
  isOpen: React.PropTypes.bool.isRequired,
  onToggle: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return {
    isOpen: state.show.loginRequiredModal,
  }
}

const mapDispatchToProps = dispatch => { 
  return {
    onToggle: _ => dispatch(toggleLoginRequiredModal()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginRequiredModal)




/** WEBPACK FOOTER **
 ** ./app/components/LoginRequiredModal.jsx
 **/